"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1() {
    if (doesMatch("no-preference")) {
        return "none" /* ContrastPreference.none */;
    }
    if (doesMatch("high") || doesMatch("more")) {
        return "more" /* ContrastPreference.more */;
    }
    if (doesMatch("low") || doesMatch("less")) {
        return "less" /* ContrastPreference.less */;
    }
    if (doesMatch("forced")) {
        return "forcedColors" /* ContrastPreference.forcedColors */;
    }
    return "error" /* ContrastPreference.error */;
}
exports.default = default_1;
const doesMatch = (value) => {
    return matchMedia(`(prefers-contrast: ${value})`).matches;
};
